import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[keyInputPrevent]',
})
export class KeyInputPreventDirective {
  private specialKeys = ['Backspace', 'Delete', 'Tab', 'Home', 'End', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'AltLeft', 'AltRight', 'Shift'];

  @Input()
  keyInputPrevent = false;

  @HostListener('keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent): void {
    const isSpecialKey = this.specialKeys.includes(event.code) || this.specialKeys.includes(event.key) || event.ctrlKey;

    if (this.keyInputPrevent && !isSpecialKey) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
